import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#5A6B83",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2"
    }, [
      _createElementVNode("path", { d: "M13.424 3.844H1.576l1.477-2.519h8.884zM13.424 3.844H1.576v9.222h11.848z" }),
      _createElementVNode("path", { d: "m5.72 8.769 1.775 1.844L9.28 8.77M7.495 6.307v4.306" })
    ], -1)
  ]))]))
}
export default { render: render }